module.exports = __webpack_public_path__ + "static/media/FuturaPTExtraBold.075bf4f8.otf";